<template>
  <div v-if="sitter" class="sitter-details">
    <Breadcrumb :href="formatProfileUrl" :header="breadcrumbHeader" :anchorLink="true" />

    <div class="flex justify-between mt-24 md:mt-48">
      <div class="flex">
        <Avatar :imageUrl="sitter.photoUrl" size="mega" :name="sitter.displayName" />
        <div class="sitter-details__stats flex flex-col">
          <h2 class="h3 sitter-details__name">{{ sitter.displayName }}</h2>
          <StarRating :showCount="true" :count="sitter.reviews.totalReviewCount" :average="sitter.reviews.starAggregate" />
          <p class="sm:hidden font-medium mt-12">{{ formatPayRate }}<span class="sitter-details__label">/hr</span></p>
        </div>
      </div>
      <p class="hidden sm:block font-medium mt-12 md:text-m2 md:mt-8">
        {{ formatPayRate }}<span class="sitter-details__label">/hr</span>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { mapGetters } from 'vuex';
import Avatar from '@/components/avatar/Avatar.vue';
import Breadcrumb from '@/components/breadcrumb/Breadcrumb.vue';
import StarRating from '@/components/star_rating/StarRating.vue';

export default {
  name: 'SitterDetails',
  components: {
    Avatar,
    Breadcrumb,
    StarRating,
  },
  computed: {
    ...mapGetters('interviewRequest', ['sitter']),
    formatProfileUrl(): string {
      return `/providers/${(this as any).sitter?.id}`;
    },
    breadcrumbHeader(): string {
      return `${(this as any).sitter?.displayName}'s profile`;
    },
    formatPayRate(): string {
      const min = (this as any).sitter?.profiles?.babysitter?.profile?.payRate?.min;
      const max = (this as any).sitter?.profiles?.babysitter?.profile?.payRate?.max;
      if (min == null || max == null) return '';
      return `$${min / 100}-${max / 100}`;
    },
  },
};
</script>
